module.exports = __webpack_public_path__ + "img/apps_storage_img.7fb8d89d.svg";